import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { type TenantUserAdminListItem } from '@bliks-io/contracts';
import { toastApiError } from '@/api/mutations/toast-api-error';
import { useResetTenantUserSignIn } from '@/pages/admin/api/mutations/useTenantUsers';
import { ResetSignInConfirmDialog } from '@/components/reset-sign-in/ResetSignInConfirmDialog';

interface ResetTenantUserSignInDialogProps {
  tenantId: string;
  /** The user to reset; the dialog is open while this is set. */
  user: TenantUserAdminListItem | undefined;
  onClose: () => void;
}

export function ResetTenantUserSignInDialog({
  tenantId,
  user,
  onClose
}: ResetTenantUserSignInDialogProps) {
  const { t } = useTranslation();
  const resetSignIn = useResetTenantUserSignIn(tenantId);

  const handleConfirm = async () => {
    if (!user) return;

    try {
      await resetSignIn.mutateAsync({ userId: user._id });
      toast.success(t('organization.members.resetSignInSuccess'));
      onClose();
    } catch (error) {
      toastApiError(error, 'adminSettings.tenant.resetSignInFailed');
      console.error('Failed to reset sign-in:', error);
    }
  };

  return (
    <ResetSignInConfirmDialog
      person={user}
      onClose={onClose}
      onConfirm={() => void handleConfirm()}
      isPending={resetSignIn.isPending}
    />
  );
}
